export default "__VITE_ASSET__0b8bc18c__"